<script>
  // import {debounce} from 'lodash'

  export default {
    name: 'u-chat-menu-options',
    data () {
      return {
        pesquisa: ''
      }
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {
      /* pesquisaUsuario: debounce(function (pesquisa) {
        this.$emit('pesquisa', pesquisa)
      }, 200) */
      pesquisaUsuario () {
        this.$emit('pesquisa', this.pesquisa)
      }
    },
    components: {}
  }
</script>

<template>
  <div class="chat-menu">
    <i class="search-icon u-ico-search"></i>
    <input class="pesquisa" @keyup="pesquisaUsuario" v-model="pesquisa" ref="inputPesquisa"
           placeholder="Pesquisar"/> <!-- :disabled="isLoadingSend" -->
  </div>
</template>



// WEBPACK FOOTER //
// ChatMenuOptions.vue?f453c786